import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  isDevMode,
  provideZoneChangeDetection,
} from "@angular/core";
import { ChunkErrorHandler } from "./common/chunk-error.handler";
import { GOOGLE_MAPS_API_KEY } from "shared-ui";
import { environment } from "src/environments/environment";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";
import { provideEffects } from "@ngrx/effects";
import { provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { provideMonacoEditor } from "ngx-monaco-editor-v2";
import { provideLucideIcons } from "@lucide/angular";
import { LUCIDE_ICON_SET } from "./common/lucide-icons";
import { routes } from "./app.routes";
import { FlowListEffects } from "./common/stores/interation-module/flows/flow-list/flow-list-effects";
import { FlowListReducer } from "./common/stores/interation-module/flows/flow-list/flow-list-reducers";
import {
  authInterceptor,
  errorInterceptor,
} from "./core/interceptors/auth.interceptor";
import {
  applyWhiteLabelingEffect,
  whiteLabelingEffect,
} from "./common/stores/whitelabeling/white-labeling.effect";
import { whiteLabelingReducer } from "./common/stores/whitelabeling/white-labeling.reducers";

// Extend the Window interface to include 'monaco'
// declare global {
//   interface Window {
//     monaco: any;
//   }
// }

// export const monacoConfig: NgxMonacoEditorConfig = {
//   onMonacoLoad: () => {
//     // Enable full validation for JavaScript (syntax + semantic)
//     (
//       window.monaco.languages.typescript.javascriptDefaults as any
//     ).setDiagnosticsOptions({
//       noSemanticValidation: false,
//       noSyntaxValidation: false,
//     });

//     // Optional: More eager checking
//     (
//       window.monaco.languages.typescript.javascriptDefaults as any
//     ).setEagerModelSync(true);
//   },
// };

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore({
      flowList: FlowListReducer,
      whiteLabeling: whiteLabelingReducer,
    }),
    provideEffects(FlowListEffects),
    provideEffects({ whiteLabelingEffect, applyWhiteLabelingEffect }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
    provideAnimations(),
    provideMonacoEditor({ baseUrl: "./assets/monaco/vs" }),
    provideLucideIcons(...LUCIDE_ICON_SET),
    { provide: GOOGLE_MAPS_API_KEY, useValue: environment.googleMapsApiKey },
    { provide: ErrorHandler, useClass: ChunkErrorHandler },
  ],
};
